import template from '@components/expertise/discovery/discovery.module.scss'
import { IDiscoveryAccordion, IDiscoveryPhaseStepsSection } from '../../discovery.state';
import style from './index.module.scss'
import Image from 'next/image'
import AccordionItem from '../../accordion/accordion';

interface DiscoveryPhaseStepsSectionProps {
    section: IDiscoveryPhaseStepsSection;
}

const DiscoveryPhaseStepsSectionComponent = ({section}: DiscoveryPhaseStepsSectionProps) => {
    return(
        <section className={`${template.section} ${template.section__block_light}`}>
                <div className={`${template.container}`}>
                    <h2 className={template.steps__title}>
                        {section.title}
                    </h2>
                    <div className={template.steps__image}>
                        <Image layout={'fill'} src={section.imgSrc} alt={section.title} />
                    </div>
                </div>
                <div className={`${template.container} ${template.container_small} ${style.container}`}>
                <div className={`${style.text}`}>
                        {section.text}
                    </div>
                    {section.accordion.map((item: IDiscoveryAccordion, index: number) => {
                        return <AccordionItem key={index} id={item.id} title={item.title} text={item.text} />
                    })}
                </div>
            </section>
    )
}

export default DiscoveryPhaseStepsSectionComponent;